export const cache = {
  store: {} as { [key: string]: any },
  async get<T>(key: string, factory: () => Promise<T>): Promise<T> {
    if (!this.store[key]) {
      this.store[key] = factory().catch((error) => {
        delete this.store[key];

        throw error;
      });
    }

    return this.store[key];
  },
};
